import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import DetailForm from './components/DetailForm.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsConversion from '@/components/TabsConversion'
import TabsContacts from '@/components/TabsContacts/index.vue'
import ConcatModal from '@/components/TabsContacts/lbu/editModal.vue'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import { addToFav, cancelToFav } from '@/api/common'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'


const __default__ = { name: 'DcCosLbuSalesClueView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const queryClueId = computed(() => route.query.clueId as string)
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
const dataForm = reactive<LbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}]
  },
  visitAddress: [{}]
})
const permissionFollow = {
  edit: 'lbu_clue_follow_edit_btn',
  del: 'lbu_clue_follow_del_btn'
}
const permissionConcat = {
  add: 'lbu_clue_contact_add_btn',
  edit: 'lbu_clue_contact_edit_btn',
  del: 'lbu_clue_contact_del_btn',
  isPublic: isPublicClue.value === '1'
}
const getDetails = () => {
  salesClueDetail({ clueId: queryClueId.value }).then((res) => {
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => getDetails())

const activeTabs = ref('info')
const operationLogRef = ref()
const handleTabsChange = (val: any) => {
  if (val === 'info') {
    getDetails()
  } else if (val === 'logs') {
    operationLogRef.value?.fetch()
  }
}

// 新增联系人
const contactsRef = ref()
const concatModalRef = ref()
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successAddConcat = (type: any) => {
  contactsRef.value?.refresh(type)
  operationLogRef.value?.fetch()
  getDetails()
}
// 跳转跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: queryClueId.value,
      returnPath: route.fullPath
    }
  })
}
const goToEdit = () => {
  router.push({
    path: '/lbu/salesClue/edit',
    query: { clueId: queryClueId.value }
  })
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_lbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = dataForm?.clueId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: dataForm.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      dataForm.collectionId = null
      dataForm.collectionTime = null
    }
  })
}
const handleTurnPotential = (row = dataForm) => {
  if (!row) return
  if (row.clueStatus === 5) return message.warning('无效线索不能转潜在客户')
  router.push({
    path: '/lbu/salesClue/potential',
    query: { clueId: row.clueId }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_CosViewContent, {
              header: "",
              title: dataForm?.customerName,
              sellerName: dataForm?.followerName,
              "collection-id": dataForm?.collectionId,
              customLabel: "联系人姓名",
              customValue: dataForm?.contact.name,
              "add-fav": addFavorite,
              "cancel-fav": cancelFavorite
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, {
                  activeKey: activeTabs.value,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                  onChange: handleTabsChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "info",
                      tab: "基本信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(DetailForm, {
                          ref: "detailFormRef",
                          type: "view",
                          isEdit: false,
                          value: dataForm,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "contact",
                      tab: "联系人"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsContacts, {
                          ref_key: "contactsRef",
                          ref: contactsRef,
                          appId: "cos_lbu",
                          contactRefId: queryClueId.value,
                          permissionPage: permissionConcat
                        }, null, 8, ["contactRefId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "record",
                      tab: "跟进记录"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsClueCosFollowUp), {
                          permissionPage: permissionFollow,
                          appId: "cos_lbu",
                          followRefId: queryClueId.value
                        }, null, 8, ["followRefId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "convert",
                      tab: "转化记录"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsConversion), {
                          appId: "cos_lbu",
                          resourceId: queryClueId.value
                        }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "logs",
                      tab: "操作日志"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TabsOperationLog, {
                          ref_key: "operationLogRef",
                          ref: operationLogRef,
                          appId: "cos_lbu",
                          tableId: "LbuSalesClueOperationLog",
                          resourceId: queryClueId.value
                        }, null, 8, ["resourceId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            }, 8, ["title", "sellerName", "collection-id", "customValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_cos_footer_button, { hideOk: true }, {
          default: _withCtx(() => [
            (!isPublicClue.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (dataForm.clueStatus !== 8)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        key: 0,
                        controlType: "none",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (goToEdit()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑 ")
                        ]),
                        _: 1
                      })), [
                        [_directive_permission, 'lbu_clue_edit_btn']
                      ])
                    : _createCommentVNode("", true),
                  (dataForm.clueStatus !== 8)
                    ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAddConcat()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增联系人 ")
                        ]),
                        _: 1
                      })), [
                        [_directive_permission, permissionConcat.add]
                      ])
                    : _createCommentVNode("", true),
                  (dataForm.clueStatus !== 8)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        key: 2,
                        workCode: dataForm.follower,
                        controlType: "none",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleTurnPotential()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("转为潜在客户 ")
                        ]),
                        _: 1
                      }, 8, ["workCode"])), [
                        [_directive_permission, 'lbu_clue_potential_btn']
                      ])
                    : _createCommentVNode("", true),
                  (dataForm.clueStatus !== 8)
                    ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        key: 3,
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleWriteFollowUp()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("写跟进 ")
                        ]),
                        _: 1
                      })), [
                        [_directive_permission, 'lbu_clue_write_follow_btn']
                      ])
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: successAddConcat,
      contactRefId: queryClueId.value
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})